import Swiper from "swiper/bundle";

(function ($) {
    $(document).ready(function () {

        const swiper = new Swiper(".contact-blocks-slider", {
            slidesPerView: 3,
            spaceBetween: 8,
            loop: false,
            speed: 1000,
            pagination: {
                el: ".contact-blocks .swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".contact-blocks .swiper-button-next",
                prevEl: ".contact-blocks .swiper-button-prev",
            },
            breakpoints: {
                1100: {
                    slidesPerView: 3,
                },
                900: {
                    slidesPerView: 2.5,
                },
                600: {
                    slidesPerView: 2,
                },
                1: {
                    slidesPerView: 1.2,
                },
            }
        });
    });

})(jQuery);
